<template>
  <li class="nav-item dropdown d-none d-sm-block">
    <a class="nav-link" @click="toggle_notification_list" role="button">
      <i class="icon md-notifications" aria-hidden="true"></i>

      <span v-if="messages_error">
        <span class="badge badge-light up badge-notify-js">
          <i class="fa fa-exclamation-triangle" aria-hidden="true" />
        </span>
      </span>

      <span v-if="!messages_error && messages_loading">
        <span class="badge badge-light up badge-notify-js">
          <i class="fa fa-spinner fa-pulse" aria-hidden="true" />
        </span>
      </span>

      <span v-if="!messages_error && !messages_loading">
        <span v-if="unread_messages.length" class="badge badge-pill badge-danger up badge-notify-js">
          {{ unread_messages.length }}
        </span>
      </span>
    </a>

    <div class="dropdown-menu dropdown-menu-right dropdown-menu-media dropdown-menu-notify"
      :class="{ show: show_notification_list }" role="menu">
      <div class="bell-notify">


        <div class="bell-notify__heading">
          <div class="bell-notify__title">
            <h6>УВЕДОМЛЕНИЯ</h6>
          </div>
          <span class="badge badge-pill badge-danger mr-2 badge-notify-js"></span>
          <div v-if="unread_messages.length" id="read_all" class="bell-notify__btn">

            <i v-if="reading_all_error" class="fa fa-exclamation-triangle" aria-hidden="true" data-toggle="tooltip"
              data-placement="right" data-original-title="Ошибка!" />

            <i v-if="!reading_all_error && reading_all_loading" class="fa fa-spinner fa-pulse" aria-hidden="true"
              data-toggle="tooltip" data-placement="right" data-original-title="Загрузка..." />

            <i v-if="!reading_all_error && !reading_all_loading" @click="readMessages()" id="bellCheckAll"
              class="icon md-check-all" data-toggle="tooltip" data-placement="left"
              data-original-title="Отметить все сообщения прочитанными"></i>
          </div>
        </div>

        <div id="bellNotifyTab" class="bell-notify__tab">
          <ul class="nav nav-tabs" role="tablist">
            <li class="nav-item">
              <a class="nav-link active" id="notify-read-tab" data-toggle="tab" href="#notify-read" role="tab"
                aria-controls="notify-read" aria-selected="true">Новые</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" id="notify-unread-tab" href="#notify-unread" data-toggle="tab"
                aria-controls="exampleTabsTwo" role="tab">
                <div class="d-flex justify-content-center">
                  <span>Прочитанные</span>
                  <div class="help-sign-mini qform-help pl-10" data-toggle="tooltip" id="bellNotifyHelp" rel="tooltip"
                    title="" data-original-title="Сообщения хранятся 30 дней">
                    <i class="md md-help-outline"></i>
                  </div>
                </div>
              </a>
            </li>
          </ul>

          <div class="tab-content">
            <div class="tab-pane active" id="notify-read" role="tabpanel" aria-labelledby="notify-read-tab">
              <span v-if="unread_messages.length">
                <notification-bell-message v-for="message in unread_messages" :key="message.id" :item="message"
                  @read="readMessages">
                </notification-bell-message>
              </span>

              <div v-else class="stack stack--notice">
                <span>У вас нет новых уведомлений</span>
              </div>
            </div>

            <div class="tab-pane" id="notify-unread" role="tabpanel" aria-labelledby="notify-unread-tab">
              <span v-if="read_messages.length">
                <div class="bell-notify__item" role="menuitem">
                  <notification-bell-message v-for="message in read_messages" :key="message.id" :item="message">
                  </notification-bell-message>
                </div>
              </span>

              <div v-else class="stack stack--notice">
                <span>У вас нет новых уведомлений</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </li>
</template>

<script>
import NotificationBellMessage from './NotificationBellMessage.vue';


export default {
  name: 'NotificationBell',
  components: { NotificationBellMessage },
  data() {
    return {
      messages_loading: false,
      messages_error: false,
      show_notification_list: false,
      read_messages: [],
      unread_messages: [],
      reading_all_loading: false,
      reading_all_error: false,
      timer: null,
    };
  },
  methods: {
    toggle_notification_list() {
      this.show_notification_list = !this.show_notification_list;
    },
    // Скрываем окно при клике вне окна уведомлений
    handleClickOutside(event) {
      const bellNotifyTab = this.$el.querySelector('#bellNotifyTab');
      if (bellNotifyTab && !bellNotifyTab.contains(event.target) && !this.$el.contains(event.target)) {
        this.show_notification_list = false;
      }
    },
    async getMessages() {
      this.messages_loading = true;
      this.messages_error = false;

      this.read_messages = [];
      this.unread_messages = [];

      axios.get('/bell/list').then(response => {

        response.data.forEach((elem) => {
          if (elem.read_at) {
            this.read_messages.push(elem);
          } else {
            this.unread_messages.push(elem);
          }
        });

        this.messages_loading = false;
      }).catch(err => {
        this.messages_error = true;
        console.log(err);
      });
    },
    async readMessages(id = null) {
      if (!id) { // read all
        this.reading_all_loading = true;
        this.reading_all_error = false;
      }

      const data = {
        ids: id !== null ? [id] : this.unread_messages.map(elem => elem.id),
      };

      axios.put('/bell/read', data).then(response => {
        this.unread_messages = this.unread_messages.filter((elem) => {
          if (data.ids.indexOf(elem.id) !== -1) {
            elem.read_at = (new Date()).toLocaleDateString();
            this.read_messages.unshift(elem);
            return false;
          }

          return true;
        });

        if (!id) {
          this.reading_all_loading = false;
        }
      }).catch(err => {
        if (!id) {
          this.reading_all_loading = false;
          this.reading_all_error = true;
        }

        console.log(err);
      });
    },
  },
  mounted() {
    this.getMessages();
    // Слушаем событие клика для скрытия окна уведомлений
    document.addEventListener('click', this.handleClickOutside);
    this.timer = setInterval(() => {
      if (!this.show_notification_list) {
        this.getMessages();
      }
    }, 30000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
    // Удаляем слушатель событие клика
    document.removeEventListener('click', this.handleClickOutside);
  },
};
</script>

<style scoped>
.dropdown .fa {
  color: #636b6f;
  font-size: 11pt;
}

.bell-notify .nav-tabs {
  margin: 0;
}

.bell-notify .disabled {
  opacity: 0.5;
  pointer-events: none;
}

.bell-notify .nav-link {
  padding: 0.7rem 0.5rem !important;
  text-align: center;
}

.bell-notify__btn {
  opacity: 0.5;
  transition: opacity 0.5s;
  font-size: 14pt;
  color: #ff6611;
  cursor: pointer;
}

.bell-notify__btn:hover {
  opacity: 1;
}

.bell-notify .nav-item {
  flex-basis: 47% !important;
}

.bell-notify__heading {
  display: flex;
  align-items: center;
  padding: 0.5rem 1.4rem;
  border-bottom: 1px solid #e0e0e0;
}

.bell-notify__title {
  flex-grow: 1;
  color: #292521;
}

.stack-right i {
  font-size: 14pt
}

.stack {
  position: relative;
  display: flex;
  align-items: center;
  padding: 0.5rem 2rem;
  cursor: pointer;
  transition: background-color .5s
}

.stack--notice {
  background-color: #ebebeb;
  color: #8d8d8d;
  padding: 0.8rem 2rem;
  transition: color .3s;
}

.stack--notice:hover {
  color: #ff6611;
}

.stack:active {
  border-left: 3px #ff6611 solid;
}

.stack-content {
  margin: 0 0.5rem;
  flex-grow: 1;
}

.stack::before {
  content: '';
  position: absolute;
  bottom: 0px;
  height: 1px;
  width: 80%;
  background-color: #efefef;
}

.stack-left {
  align-self: flex-start;
  margin-top: 12px;
}

.stack:hover {
  background-color: #efefef;
}
</style>
